import { create } from 'zustand';

type ConversionProgressStore = {
  clearConverting: () => void;
  safeIds: string[];
  setConverting: (safeIds: string[]) => void;
  startedAt: null | number;
};

export const useSafeConversionProgressStore = create<ConversionProgressStore>()((set) => ({
  safeIds: [],
  startedAt: null,
  setConverting: (safeIds) => set({ safeIds, startedAt: Date.now() }),
  clearConverting: () => set({ safeIds: [], startedAt: null }),
}));
